import { Card, Stack, Title } from "@mantine/core";
import React from "react";

export interface SettingsCardWrapperProps {
  title: string;
  children: React.ReactNode;
}

const SettingsCardWrapper: React.FC<SettingsCardWrapperProps> = ({ title, children }) => {
  return (
    <Card px="md" py="sm" shadow="xs" style={{ overflow: "visible" }} radius="sm">
      <Stack gap="xs">
        <Title order={4} style={{ fontWeight: 400 }}>
          {title}
        </Title>
        {children}
      </Stack>
    </Card>
  );
};

export default SettingsCardWrapper;
